import { useEffect, useState } from "react";

// Styles
import styles from "./tooltip.module.css";

interface TooltipProps {
  open?: boolean;
  children: React.ReactNode;
  label: string | React.ReactNode;
  classes?: { tooltipContainer?: string; tooltip?: string };
}

const Tooltip: React.FC<TooltipProps> = ({ open = false, children, label, classes }) => {
  const [isHovered, setIsHovered] = useState(open);

  useEffect(() => {
    setIsHovered(open);
  }, [open]);

  let tooltipContainerClass = styles.tooltipContainer;
  let tooltipClass = styles.tooltip;
  if (classes?.tooltipContainer) tooltipContainerClass += ` ${classes.tooltipContainer}`;
  if (classes?.tooltip) tooltipClass += ` ${classes.tooltip}`;

  return (
    <div
      className={tooltipContainerClass}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => !open && setIsHovered(false)}
    >
      {children}

      {isHovered && (
        <div className={tooltipClass}>
          {label}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
